import { render, staticRenderFns } from "./UniversityImages.vue?vue&type=template&id=1590db8c&"
import script from "./UniversityImages.vue?vue&type=script&lang=js&"
export * from "./UniversityImages.vue?vue&type=script&lang=js&"
import style0 from "./UniversityImages.vue?vue&type=style&index=0&id=1590db8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports